export default "__VITE_ASSET__DXtCtVc4__"